export const IndotechButtonSizes = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
};
